import React, {useState} from 'react';
import { useShareRecall } from '../Components/useShareRecall';
import ShareIcon from '../Components/ShareIcon';

const Card = ({ item, onImageClick, onOpenDetails }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const { share, justCopied } = useShareRecall();

    const cardClass = 'small-card';

    const openPopup = () => onOpenDetails(item);

    // Get images from either structure
    const images = item.images && item.images.length > 0
        ? item.images
        : (item.details?.images && item.details.images.length > 0 ? item.details.images : []);

    const hasImages = images.length > 0;
    const currentImage = hasImages ? images[currentImageIndex] : null;
    const currentImageUrl = currentImage?.url || currentImage?.src;
    const currentImageAlt = currentImage?.fileName || currentImage?.alt;

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const handleShare = (e) => {
        e.stopPropagation();
        share(item);
    };

    return (
        <div className={cardClass}>
                <div className="card-body">
                    <div className='card-content'>
                        {hasImages ? (
                            <div className="card-carousel">
                                {images.length > 1 && (
                                    <button className="carousel-btn prev-btn" onClick={prevImage}>❮</button>
                                )}
                                <img
                                    src={currentImageUrl}
                                    alt={currentImageAlt}
                                    className="card-image"
                                    onClick={() => onImageClick(currentImageUrl)}
                                    style={{ cursor: 'pointer' }}
                                />
                                {images.length > 1 && (
                                    <button className="carousel-btn next-btn" onClick={nextImage}>❯</button>
                                )}
                                {images.length > 1 && (
                                    <span className="carousel-counter">{currentImageIndex + 1} / {images.length}</span>
                                )}
                            </div>
                        ) : null}
                        <h5 className="card-title" onClick={openPopup} style={{ cursor: 'pointer' }}>{item.title}</h5>
                        <div className="card-meta-row">
                            <p className="card-text">{item.formattedDate}</p>
                            <button
                                className="share-button"
                                onClick={handleShare}
                                aria-label="Jaa takaisinveto"
                                type="button"
                            >
                                <ShareIcon />
                                {justCopied && <span className="share-tooltip">Linkki kopioitu!</span>}
                            </button>
                        </div>
                    </div>
                    <button className="card-button" onClick={openPopup}>Lisätiedot</button>
                </div>
        </div>
    );
};

export default Card;
